import { Flex, type FlexProps, Text } from '@/components';
import { FALLBACK_TEXT } from '@/utils';
import { type FC, type ReactNode, isValidElement } from 'react';
import {
  LEDGER_BG_COLOR,
  LEDGER_BORDER,
  LEDGER_MIDDLE_CAPTION_WIDTH,
  LEDGER_PADDING,
} from '../../../utils';

type ContentItemProps = {
  label?: string;
  isSpaceLabel?: boolean;
  value: ReactNode;
  valueWrapperStyle?: FlexProps['style'];
  wrapperStyle?: FlexProps['style'];
  labelStyle?: FlexProps['style'];
  isLast?: boolean;
  noneBorder?: boolean;
};

/**
 * @deprecated
 * ReportSectionItemContentを使うようにする
 */
export const ContentItem: FC<ContentItemProps> = ({
  label,
  isSpaceLabel,
  value,
  labelStyle,
  wrapperStyle,
  valueWrapperStyle,
  isLast,
  noneBorder,
}) => {
  return (
    <Flex
      style={{
        flex: 1,
        borderBottom: isLast ? undefined : LEDGER_BORDER,
        breakInside: 'avoid',
        ...wrapperStyle,
      }}
    >
      {(label || isSpaceLabel) && (
        <Flex
          align="center"
          style={{
            padding: LEDGER_PADDING,
            background: LEDGER_BG_COLOR,
            borderRight: LEDGER_BORDER,
            borderLeft: noneBorder ? undefined : LEDGER_BORDER,
            width: LEDGER_MIDDLE_CAPTION_WIDTH,
            minWidth: LEDGER_MIDDLE_CAPTION_WIDTH,
            boxSizing: 'border-box',
            ...labelStyle,
          }}
        >
          <Text variant="footnote" text={isSpaceLabel ? '' : label} />
        </Flex>
      )}
      {isValidElement(value) ? (
        <>{value}</>
      ) : (
        <Flex
          align="center"
          style={{
            flex: 1,
            padding: LEDGER_PADDING,
            ...valueWrapperStyle,
          }}
        >
          <Text
            variant="footnote"
            text={
              (value as string | number | undefined | null) || FALLBACK_TEXT
            }
          />
        </Flex>
      )}
    </Flex>
  );
};
